import { PaymentDirection } from '@b7hio/api-lib/src/ops-portal';
import { FormAutocomplete, FormDateRangePicker } from '@b7hio/core-lib/src';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const TransactionListFilter: React.FC = () => {
  const { t } = useTranslation(['common', 'transactions']);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { control } = useFormContext<any>();
  const paymentDirection = Object.values(PaymentDirection).map((type) => ({
    value: type,
    label: t(`common:paymentDirection.${type}`),
  }));

  return (
    <>
      <FormAutocomplete
        name="paymentDirection"
        label={t('transactions:filter.paymentDirection')}
        test-id="type"
        t={t}
        control={control}
        options={paymentDirection}
        size="small"
      />
      <FormDateRangePicker
        nameFrom={`startDate`}
        nameTo={`endDate`}
        labelFrom={t('transactions:filter.startDate')}
        labelTo={t('transactions:filter.endDate')}
        t={t}
        control={control}
        size="small"
        hideMiddle
        gap={1}
      />
    </>
  );
};
